import HotelDetailsStepper from "../components/HotelDetailsStepper/HotelDetailsStepper";
import Wizard from "../components/HotelDetailsWizard/HotelDetailsWizard";
import HotelSidebar from "../components/HotelSidebar/HotelSidebar";
import CountdownTimerSlider from "../../../Components/CountdownTimerSlider/CountdownTimerSlider";

export default function HotelDetailsWeb() {
  return (
    <div className="w-full! flex flex-col">
      <div className="flex w-full flex-1 items-center">
        <div className="lg:gap-30 gap-10 bg-background-default border-border-default flex w-full flex-1 items-center justify-center gap-5 justify-self-center border-b p-4">
          <div className="flex-1">
            <HotelDetailsStepper />
          </div>
        </div>
      </div>
      <div className="sticky top-0 z-10">
        <CountdownTimerSlider />
      </div>
      <div className="md:px-15 flex w-full items-start justify-between gap-10 p-4 md:p-10">
        <div className="flex min-w-0 flex-1">
          <Wizard />
        </div>
        <div className="flex w-96 shrink-0 flex-col gap-3">
          <HotelSidebar />
        </div>
      </div>
    </div>
  );
}
